import React from 'react'
import { FiltersBarView } from './FiltersBarView'
import { IFiltersBarView } from './interfaces'

export const FiltersBar: React.FC<IFiltersBarView> = ({ removeFilter, isAppliedFilters }) => {
  return <FiltersBarView isAppliedFilters={isAppliedFilters} removeFilter={removeFilter} />
}
